<template functional>
  <!-- <span v-if="$options.formatDate(props.row[props.column])">
    <i class="el-icon-time"></i>
    {{ $options.formatDate(props.row[props.column]) }}
  </span> -->

  <a v-if="props.month > 0" href="#" @click="$options.Selected(props)">
    {{ $options.MothValue(props) }}
  </a>
  <span v-else>{{ $options.MothValue(props) }}</span>
</template>

<script>
import { formatMonto } from "../../utils";
export default {
  name: "DatetimeFormatter",
  Selected(props) {
    const { month } = props;
    const { VendorCode } = props.row;
    const type = props.getType();
    var a = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
    const MothValue = Number(props.row[a]);

    if (MothValue <= 0) {
      return;
    }
    //console.log("HYPER LINK BROKEN -->",props);
    props.OpenSelection(month, VendorCode, props.row.ExecutiveName, props.row);
  },
  MothValue(props) {
    const type = props.getType();
    var a = `${props.column}${type !== "Cantidad" ? "Amount" : ""}`;
    if (type === "Monto") {
      if (Number(props.row[a]) > 0) {
        return formatMonto(props.row[a]);
      } else {
        return "";
      }
    } else {
      if (Number(props.row[a]) > 0) {
        return Number(props.row[a]);
      } else {
        return "";
      }
    }
  }
};
</script>
